// First-enable Prompt coach welcome (ipa-training-mode epic; `training_mode` is
// the wire/localStorage field name — UI copy says "Prompt coach").
//
// Shown once, the first time an eligible user/technician turns Prompt coach ON
// via the drawer footer toggle. Prompt coach is the umbrella that switches on
// IP Assistant's coaching features (Prompt Coach, Smart Nudges, ...) — the modal
// introduces that umbrella and its features. It is dismissible (× / Escape /
// backdrop) and non-blocking; "Got it" is the single acknowledgement.
//
// Built on the shared Quimby Modal primitive (@ui/molecules/Modal), so focus
// trapping, Escape-to-close, and focus-restore-on-close are handled for us.
// Anchored inside the widget drawer (via `anchor`) so it stays scoped to the
// assistant.
import React from 'react';
import { translate } from '@utils/i18n';
import { Modal } from '@ui/molecules/Modal/Modal';
import { ModalHeader } from '@ui/molecules/Modal/ModalHeader';
import { ModalBody } from '@ui/molecules/Modal/ModalBody';
import { ModalFooter } from '@ui/molecules/Modal/ModalFooter';
import { Button } from '@ui/atoms/Button/Button';
import { Text } from '@ui/atoms/Text/Text';
import './CoachWelcomeModalStyles.scss';
const BASE_CLASS = 'ai-coach-welcome-modal';
const TITLE_ID = 'ai-training-mode-welcome-title';
const SUBTITLE_ID = 'ai-training-mode-welcome-subtitle';
const I18N_NAMESPACE = 'features.ai_chat_widget.welcome_modal';
// Features that Prompt coach switches on. Add future coaching features here as
// they ship — Smart Nudges is intentionally described generically so new nudge
// types fit without a copy change.
function getFeatures() {
    return [
        {
            icon: 'fa-solid fa-graduation-cap',
            name: translate('prompt_coach_feature_name', { namespace: I18N_NAMESPACE }),
            body: translate('prompt_coach_feature_body', { namespace: I18N_NAMESPACE })
        },
        {
            icon: 'fa-solid fa-wand-magic-sparkles',
            name: translate('smart_nudges_feature_name', { namespace: I18N_NAMESPACE }),
            body: translate('smart_nudges_feature_body', { namespace: I18N_NAMESPACE })
        }
    ];
}
export function CoachWelcomeModal({ isOpen, onComplete, onDismiss, anchor }) {
    return (React.createElement(Modal, { isOpen: isOpen, onClose: onDismiss, ariaLabelledBy: TITLE_ID, ariaDescribedBy: SUBTITLE_ID, className: `${BASE_CLASS}__modal`, container: anchor !== null && anchor !== void 0 ? anchor : undefined },
        React.createElement(ModalHeader, { title: translate('title', { namespace: I18N_NAMESPACE }), subtitle: translate('subtitle', { namespace: I18N_NAMESPACE }), titleId: TITLE_ID, subtitleId: SUBTITLE_ID, onClose: onDismiss, showDivider: false }),
        React.createElement(ModalBody, { className: `${BASE_CLASS}__body` },
            React.createElement("ul", { className: `${BASE_CLASS}__features` }, getFeatures().map((feature) => (React.createElement("li", { key: feature.name, className: `${BASE_CLASS}__feature` },
                React.createElement("span", { className: `${BASE_CLASS}__feature-icon`, "aria-hidden": "true" },
                    React.createElement("i", { className: feature.icon })),
                React.createElement("div", { className: `${BASE_CLASS}__feature-text` },
                    React.createElement(Text, { variant: "small", as: "strong", className: `${BASE_CLASS}__feature-name` }, feature.name),
                    React.createElement(Text, { variant: "body", as: "p", className: `${BASE_CLASS}__feature-body` }, feature.body))))))),
        React.createElement(ModalFooter, null,
            React.createElement(Button, { variant: "primary", onClick: onComplete }, translate('got_it', { namespace: I18N_NAMESPACE })))));
}
